import { render, staticRenderFns } from "./invadobay.vue?vue&type=template&id=066d4947&scoped=true"
import script from "./invadobay.vue?vue&type=script&lang=js"
export * from "./invadobay.vue?vue&type=script&lang=js"
import style0 from "./invadobay.vue?vue&type=style&index=0&id=066d4947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d4947",
  null
  
)

export default component.exports